import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  SELECTED_BANK,
  SOLICITUD_VIA_PAGO_RESPONSE,
} from "@constants/cambio-via-pago-properties.constants";
import { ModalService } from "@services/modal/modal.service";
import { StepsService } from "@services/steps/steps.service";

import { BASIC_CLIENT_INFO } from "@constants/data-service.constant";
import { ROUTING_CAMBIO_VIA_PAGO_PENSION } from "@constants/url.constant";
import { ISelectedBank } from "@interfaces/seleted-bank.interface";
import { StorageService } from "@services/storage/storage.service";
import { Util } from "@shared/common/utils/util";
import { Subscription } from "rxjs";
import { CambioViaPagoPensionService } from "../../core/services/cambio-via-pago-pension.service";

@Component({
    selector: "app-cambio-via-pago-confirmar",
    templateUrl: "./cambio-via-pago-confirmar.component.html",
    styleUrls: ["./cambio-via-pago-confirmar.component.scss"],
    standalone: false
})
export class CambioViaPagoConfirmarComponent implements OnInit, OnDestroy {
  public isError: boolean = false;
  public loading: boolean = false;
  email: string = "";
  celular: string = "";
  cuentaBancariaSeleccionada: ISelectedBank;
  token: string;
  sub = new Subscription();
  subject: string = "Cambio de vía de pago de pensión";
  attempt: boolean = false;

  constructor(
    private readonly stepsService: StepsService,
    private readonly modalService: ModalService,
    private readonly _router: Router,
    private readonly storageService: StorageService,
    private readonly _cambioViaPagoPensionService: CambioViaPagoPensionService,
    private readonly _util: Util,
  ) {
    stepsService.setCurrentStep(3);
  }

   ngOnInit() {
    this.loading = true;
    void this.initializeComponent();
  }

  private async  initializeComponent() {
    const infoClient = await this.storageService.get(BASIC_CLIENT_INFO);
    const selectedBank: ISelectedBank = await this.storageService.get(
      SELECTED_BANK
    );
    this.token = await this._util.getIdToken();
    this.email = infoClient.email;
    this.celular = infoClient.cellphoneNumber;
    this.cuentaBancariaSeleccionada = selectedBank;
    this.loading = false;
  }



  async exit() {
    await this.modalService.cambioViaPagoExitModal();
  }

  async gotoComprobante() {
    this.attempt = true;
    this.sub.add(
      this._cambioViaPagoPensionService
        .solicitudCambioViaPago(this.token, this.cuentaBancariaSeleccionada)
        .subscribe({
          next: (res) => {
            res.subject = this.subject;
            this.attempt = false;
            this.storageService.set(SOLICITUD_VIA_PAGO_RESPONSE, res);
            this._router.navigate([
              ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_BASE,
              ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_URL,
              ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_COMPROBANTE,
            ]);
          },
          error: () => {
            this.getErrorSolicitud();
          }
        })
    );
  }

  getErrorSolicitud() {
    this.attempt = false;
    this._router.navigate([
      ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_BASE,
      ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_URL,
      ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_ERROR,
    ]);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
